<template>
	<table class="table table-hover mb-0" ref="links-table">
		<thead >
			<tr>
				<th class="has-elements-visible-on-hover">
					<span  @click="sortItemsBy('title')"  class="clickable" :title="$t('click_to_sort_items_by_this_field')">{{ $t('title_as_name') }}<i class="fas ml-2" :class="sortingIcon('title')"></i></span></th>
				<th class="has-elements-visible-on-hover">
					<div class="d-flex">
						<span  @click="sortItemsBy('category')" class="clickable flex-grow-0" :title="$t('click_to_sort_items_by_this_field')">
							{{ $t('category') }}<i class="fas ml-2" :class="sortingIcon('category')"></i></span>
						<span v-if="hasElementsFilteredByCategorySubcategory" class="flex-grow-1 text-right"><i class="fa fa-filter" @click.prevent="clickCleanFilterSubcategoryHandler" :title="$t('documents_filtered_by_category_subcategory')"></i></span>
					</div>
				</th>
				<th class="has-elements-visible-on-hover">
					<span  @click="sortItemsBy('subcategory')"  class="clickable" :title="$t('click_to_sort_items_by_this_field')">{{ $t('subcategory') }}<i class="fas ml-2" :class="sortingIcon('subcategory')"></i></span></th>
				<th  class="has-elements-visible-on-hover" :title="$t('click_to_sort_items_by_this_field')">
					<span @click="sortItemsBy('language')" class="clickable" :title="$t('click_to_sort_items_by_this_field')">{{ $t('language') }}<i class="fas ml-2" :class="sortingIcon('language')"></i></span>
					<i v-if="hasElementsFilteredByLanguage" class="fa fa-filter ml-2" @click.stop.prevent="clickCleanFilterLanguageHandler"  :title="$t('documents_filtered_by_language')"></i></th>
				<th class="has-elements-visible-on-hover">
					<span  @click="sortItemsBy('description')"  class="clickable" :title="$t('click_to_sort_items_by_this_field')">{{ $t('description_as_title') }}<i class="fas ml-2" :class="sortingIcon('description')"></i></span></th>
				<th class="has-elements-visible-on-hover">
					<span  @click="sortItemsBy('documentModified')"  class="clickable" :title="$t('click_to_sort_items_by_this_field')">{{ $t('modified') }}<i class="fas ml-2" :class="sortingIcon('documentModified')"></i></span></th>
			</tr>
		</thead>
		<tbody>
			<single-document-link v-for="(item, index) in documentsFiltered"
				:key="item.id"
				:item="item"
				:clientHeight= "clientHeight"
				:clientWidth= "clientWidth"
				:displayFamilyUpdates="version.series.family.searchForUpdates"
				:seriesIncludedInPendrive="version.series.includedInPendrive"
				:userCanEditItems="version.documentationLinksList.userCanEditItems"
				@clickCategoryFilter="clickCategoryFilterHandler(index)"
				@clickSubcategoryFilter="clickSubcategoryFilterHandler(index)"
				@commentIconClicked="commentIconClickedHandler(index)"
				@copyLinkToClipboard="copyLinkToClipboardHandler(index)"
				@editItemClicked="editItemClickedHandler(index)"
				@favoriteIconClicked="favoriteIconClickedHandler(index)"
				@itemTitleClicked="itemTitleClickedHandler(index)"
				@showHistoryVersionClicked="showHistoryVersionClickedHandler(index)"/>
		</tbody>
	</table>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import SingleDocumentLink from './SingleDocumentLink.vue';

export default {
	props: ['version', 'documentsFiltered', 'clientHeight', 'clientWidth'],

	components: {
		'single-document-link': SingleDocumentLink,
	},

	data() {
		return {
			sortingCriteria: null,
			sortingDirection: 1,
		};
	},

	computed: {
		...mapGetters(['documentationSubcategoriesDisplayedIds', 'documentationLanguagesDisplayedTitle']),
		...mapState(['documentationSubcategories']),

		hasElementsFilteredByCategorySubcategory() {
			return this.documentationSubcategoriesDisplayedIds.length !== this.documentationSubcategories.length;
		},

		hasElementsFilteredByLanguage() {
			return this.documentationLanguagesDisplayedTitle.length > 0;
		},
	},

	methods: {
		...mapActions(['getDocumentationLinkItems']),

		clickCleanFilterLanguageHandler() {
			this.$emit('clickCleanFilterLanguage');
		},

		clickCleanFilterSubcategoryHandler() {
			this.$emit('clickCleanFilterSubcategory');
		},

		clickCategoryFilterHandler(itemIndex) {
			this.$emit('clickCategoryFilter', itemIndex);
		},

		clickSubcategoryFilterHandler(itemIndex) {
			this.$emit('clickSubcategoryFilter', itemIndex);
		},

		commentIconClickedHandler(itemIndex) {
			this.$emit('commentIconClicked', this.version, itemIndex);
		},

		copyLinkToClipboardHandler(itemIndex) {
			this.$emit('copyLinkToClipboard', this.version, itemIndex);
		},

		editItemClickedHandler(itemIndex) {
			this.$emit('editItemClicked', this.version, itemIndex);
		},

		favoriteIconClickedHandler(itemIndex) {
			this.$emit('favoriteIconClicked', this.version, itemIndex);
		},

		itemTitleClickedHandler(itemIndex) {
			this.$emit('itemTitleClicked', this.version, itemIndex);
		},

		showHistoryVersionClickedHandler(itemIndex) {
			this.$emit('showHistoryVersionClicked', this.version, itemIndex);
		},

		sortingIcon(criteria) {
			if (criteria === this.sortingCriteria) return this.sortingDirection === 1 ? 'fa-sort-alpha-up' : 'fa-sort-alpha-down-alt';

			return ' visible-on-hover fa-sort-alpha-up';
		},

		sortItemsBy(criteria) {
			this.$emit('sortItemsBy', criteria);
			this.sortingDirection = criteria === this.sortingCriteria ? -this.sortingDirection : 1;
			this.sortingCriteria = criteria;
		},
	},

	mounted() {
		if (!this.version.documentationLinksList.contentLoaded) {
			this.getDocumentationLinkItems(this.version).then(() => {
				// this.version.documentationLinksList.contentLoaded = true;
				this.sortItemsBy('title');
			}).catch((error) => console.error('[PRODUCTS] Error at DocumentLinks.mounted.getDocumentationLinkItems', error));
		} else {
			this.sortItemsBy('title');
		}
	},
};
</script>
